module.exports = __webpack_public_path__ + "static/media/19ESCAP16.281758a3.jpg";